<template>
    <div class="w-full">
        <onboarding-header :current-step="2" :total-steps="4">
            <template v-slot:header>
                Add a collection of searchable data
            </template>
            <template v-slot:description>
            Collections are groups of related data that your users or application will be able to search through. We also apply a machine learning layer on top of your collections for smart recommendations.
            </template>
        </onboarding-header>

        <FormulateForm @submit="updateCollection" class="mt-8 max-w-md">

            <label class="text-sm text-gray-500 leading-8" for="name">Upload CSV or JSON file of your data</label>

            <div class="h-24">
                <FormulateInput
                        type="file"
                        name="file"
                        validation="mime:text/csv,application/json"
                        accept="text/csv,application/json"
                        upload-behavior="delayed"
                        :uploader="uploadFile"
                />
            </div>


            <base-button bgColor="bg-success" borderColor="border-success" hoverBg="hover:bg-green-400" hoverBorder="hover:border-green-400" class="mt-10 mb-3" icon="fat-arrow-right" type="submit">Import Data to Project</base-button>
            <router-link :to="{ name: 'OnboardingUpdateProfile' }" tag="a" class="text-gray-500 underline focus:outline-none focus:shadow-outline">or skip to add data later</router-link>

        </FormulateForm>
    </div>
</template>

<script>
import OnboardingHeader from "../OnboardingHeader"
import { authenticationState, loading, error, currentProject } from '@/mixins';
import { uploadedCollectionData } from "@/graphql/mutations";
import { uploadCollectionData } from "@/graphql/queries";
import { BlockBlobClient } from "@azure/storage-blob";

export default {
  name: "AddCollection",
  metaInfo: {
      title: 'Add Collection',
  },
  components: {
    OnboardingHeader
  },
  mixins: [ authenticationState, loading, error, currentProject ],
  data () {
      return {
          isSubmitting: false
      }
  },
  methods: {
      async uploadFile(file, progress, error, option) {
            try {
                const presignedUrlObject = await this.$apollo.query({
                    query: uploadCollectionData,
                    variables: {
                        input: {
                            projectId: this.currentProject.id,
                            collectionId: this.currentCollection.id
                        }
                    }
                });


                const presignedUrl = presignedUrlObject.data.uploadCollectionData.presignedUrl
                const blockBlobClient = new BlockBlobClient(presignedUrl);

                await blockBlobClient.uploadBrowserData(file, 
                { blobHTTPHeaders: 
                    { blobContentType: file.type },
                    onProgress: (function progress(event) {
                        this.markProgress(parseInt(event.loadedBytes / this.fileSize * 100));
                    }).bind({ fileSize: file.size, markProgress: progress })
                } );

                await this.$apollo.mutate({
                    mutation: uploadedCollectionData,
                    variables: {
                        input: {
                            projectId: this.currentProject.id,
                            collectionId: this.currentCollection.id
                        }
                    }
                });
                
                return
            } catch (error) {
                this.handleError(error);
            }
      },
      async updateCollection() {

          if (this.isSubmitting) {
              return
          }

          this.isSubmitting = true;
          this.$root.$emit('loading', true);

          try {
            this.$router.push({ name: 'OnboardingUpdateProfile'})
          } catch (error) {
            this.handleError(error);
          }

          this.$root.$emit('loading', false);
          this.isSubmitting = false;
      }
  }
};
</script>
